import React from 'react';
import { noop } from 'lodash';
import Dropdown from '../../../../webcommon/common/formcomponents/dropdown/Dropdown';
import PropTypes from 'prop-types';
import defaultStyles from './CustomDropdown.module.scss';

const CustomDropdown = props => (
    <div className={ props.styles.dropdownWrapper }>
        <div className={ props.styles.dropdownTitle }>
            {props.title}
        </div>
        <Dropdown
            onSelection={ props.setActiveValue }
            options={ props.options }
            placeholder=""
            value={ props.activeValue }
        />
    </div>
);

CustomDropdown.propTypes = {
    activeValue: PropTypes.string,
    options: PropTypes.arrayOf(PropTypes.string),
    setActiveValue: PropTypes.func,
    styles: PropTypes.objectOf(PropTypes.string),
    title: PropTypes.string
};

CustomDropdown.defaultProps = {
    activeValue: '',
    options: [],
    setActiveValue: noop,
    styles: defaultStyles,
    title: ''
};

export default CustomDropdown;
